/**
 *  @class
 *  @function ViewProducts
 */
if (!customElements.get('view-products')) {
  class ViewProducts extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.drawer = document.querySelector(this.dataset.target);
      this.addEventListener('click', this.setupEventListener.bind(this));
      // The markup gives it role="button": Enter and Space activate it.
      this.addEventListener('keydown', (e) => {
        if (e.target !== this || e.repeat || (e.key !== 'Enter' && e.key !== ' ')) return;
        e.preventDefault();
        this.click();
      });
    }
    setupEventListener() {
      OverlayManager.open(this.drawer);
    }
  }
  customElements.define('view-products', ViewProducts);
}
